import React from "react";
import { NormalizedCargo } from "../../../../../domain/models/cargo-model";
import { Stack, Button, Container, IconButton, Chip } from "@mui/material";
import { Paper, Typography } from "@mui/material";
import { ProgressBar } from "../../components/progress-bar";
import Badge from "@mui/material/Badge";
import Tooltip from "@mui/material/Tooltip";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditIcon from "@mui/icons-material/Edit";
import { PrintCargoLabel } from "../../../../../domain/usecases/print-label/print-cargo-label";

type Props = {
  cargo: NormalizedCargo;
  printCargoLabel: PrintCargoLabel;
  onEdit: (...args: any[]) => any;
  onDelete: (...args: any[]) => any;
  onShowProducts: (...args: any[]) => any;
  delayed?: boolean;
};

const CargoCard = ({
  cargo,
  printCargoLabel,
  onEdit,
  onDelete,
  onShowProducts,
  delayed = false,
}: Props) => {
  return (
    <Container
      key={cargo.id}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Badge
        sx={{ padding: "0px" }}
        badgeContent={
          <Stack direction={"row"} spacing={1}>
            <Tooltip title={"Sobrescrever"}>
              <IconButton sx={{ backgroundColor: "grey", color: "white" }}>
                <EditIcon
                  fontSize="small"
                  sx={{ cursor: "pointer" }}
                  onClick={onEdit}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Deletar"}>
              <IconButton sx={{ backgroundColor: "red", color: "white" }}>
                <DeleteRoundedIcon
                  fontSize="small"
                  sx={{ cursor: "pointer" }}
                  onClick={onDelete}
                />
              </IconButton>
            </Tooltip>
          </Stack>
        }
        key={cargo.reference}
      >
        <Paper
          sx={{
            p: "20px",
            width: "100%",
            backgroundColor: delayed ? "#F09294" : "",
          }}
        >
          <Stack direction="row">
            <Stack sx={{ width: "30%" }}>
              <Typography fontWeight="bold">Informações Básicas</Typography>
              <Typography>{`Carga: ${cargo?.reference}`}</Typography>
              <Typography>{`Pedido: ${cargo?.orderReference}`}</Typography>
              <Typography>{`Cliente: ${cargo?.clientName}`}</Typography>
              <Typography>{`Produtos:`}</Typography>
              <Button onClick={onShowProducts}>{"Ver Lista"}</Button>
            </Stack>
            <div
              style={{
                borderLeft: "1px solid  ",
                height: "auto",
                marginRight: "5px",
              }}
            ></div>

            <Stack sx={{ width: "50%" }}>
              <Typography fontWeight="bold">Endereço de Entrega</Typography>
              <Stack direction="row">
                <Stack sx={{ width: "50%" }}>
                  <Typography>{`Endereço: ${cargo?.street}, ${cargo?.propertyNumber}`}</Typography>
                  <Typography>{`CEP: ${cargo?.cep}`}</Typography>
                  {cargo?.additionalInformation && (
                    <Typography>{`Complemento: ${cargo?.additionalInformation}`}</Typography>
                  )}
                </Stack>
                <Stack sx={{ width: "50%" }}>
                  <Typography>{`Estado: ${cargo?.federalUnit}`}</Typography>
                  <Typography>{`Bairro: ${cargo?.neighborhood}`}</Typography>
                  <Typography>{`Cidade: ${cargo?.city}`}</Typography>
                </Stack>
              </Stack>
            </Stack>
            <div
              style={{
                borderLeft: "1px solid  ",
                height: "auto",
                marginRight: "5px",
              }}
            ></div>

            <Container
              sx={{
                width: "20%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Chip
                label={
                  cargo.status === "CHECKED" ? "Conferida" : "Não conferida"
                }
                variant="outlined"
                sx={{ fontSize: "11px" }}
              />

              <ProgressBar
                items={cargo.cargoItems}
                onPrint={() => {
                  printCargoLabel.print(cargo, (error) => {
                    alert(error?.message);
                  });
                }}
              />
            </Container>
          </Stack>
        </Paper>
      </Badge>
    </Container>
  );
};

export default CargoCard;
